import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function ClinicalTrialManagementPlatform() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'IT Solutions for Pharma', 'Clinical Trial Management Platform']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          IT Solutions for Pharma
        </h2>

        <div className="flex items-center gap-2 mb-2">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Clinical Trial Management Platform
          </h3>
        </div>

        <p className="mb-4 text-[#05326D]">End-to-End Digital Solution for Phase I–IV Trials Across Global Markets</p>

        <p className="mb-6 text-[#05326D]">
          Our Clinical Trial Management (CTM) platform is a comprehensive, cloud-enabled solution designed to streamline the planning, execution, and
          oversight of clinical trials—from early-phase studies to post-approval surveillance. Built for Contract Research Organizations (CROs),
          pharmaceutical companies, and biotech innovators, this unified system ensures full compliance with protocol obligations and global regulatory
          standards.
        </p>
        <p className="mb-8 text-[#05326D]">
          Whether managing BA/BE studies, oncology trials, or multi-centric global projects, our platform empowers teams to operate with precision,
          transparency, and speed.
        </p>

        <hr className="border-t border-gray-300 mb-8" />


        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Trial Types Supported
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Phase I to Phase IV Clinical Trials</p>
        <p className="ml-2 mt-2 text-[#05326D]">Early & Late Phase Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Oncology Trials</p>
        <p className="ml-2 mt-2 text-[#05326D]">Post-Marketing Surveillance</p>
        <p className="ml-2 mt-2 text-[#05326D]">Bioavailability & Bioequivalence (BA/BE) Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Multi-period, Multi-center Trial Management</p>



        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Key Capabilities
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Biometric/Iris-Based Registration & Screening</p>
        <p className="ml-2 mt-2 text-[#05326D]">Secure Data Management & Archival</p>
        <p className="ml-2 mt-2 text-[#05326D]">Data Export in PDF, Excel, and CDISC Formats</p>
        <p className="ml-2 mt-2 text-[#05326D]">Real-Time Project Progress Tracking</p>
        <p className="ml-2 mt-2 text-[#05326D]">Intuitive eCRF & EDC Design Tools</p>
        <p className="ml-2 mt-2 text-[#05326D]">Multi-Level Electronic Review Workflows</p>
        <p className="ml-2 mt-2 text-[#05326D]">Medical Coding Integration (MedDRA, WHODD)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Automated Scheduling & Activity Slotting</p>
        <p className="ml-2 mt-2 text-[#05326D]">Email Alerts & Notifications</p>
        <p className="ml-2 mt-2 text-[#05326D]">Machine Integration for Clinical Devices</p>

        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Compliance & Security
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Fully compliant with 21 CFR Part 11, GxP, and GCP standards</p>
        <p className="ml-2 mt-2 text-[#05326D]">Robust audit trail for traceability</p>
        <p className="ml-2 mt-2 text-[#05326D]">Role-based access control and workflow management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Successfully passed audits by USFDA, MHRA, and other global authorities</p>



        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Platform Benefits
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Centralized trial oversight across geographies and phases</p>
        <p className="ml-2 mt-2 text-[#05326D]">Enhanced data integrity and regulatory readiness</p>
        <p className="ml-2 mt-2 text-[#05326D]">Reduced operational complexity and manual effort</p>
        <p className="ml-2 mt-2 text-[#05326D]">Scalable architecture for small to large-scale studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Seamless integration with clinical systems and devices</p>


        <p className="text-[#05326D] mt-4">
          Our CTM platform is more than a tool—it’s a strategic enabler for clinical excellence, regulatory compliance, and accelerated drug development.
        </p>
      </div>
    </div>
  );
}

export default ClinicalTrialManagementPlatform;
